// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"spinLoader_loaderWrapper__Jvw17","text":"spinLoader_text__00zbC","lds-roller":"spinLoader_lds-roller__QImm3"};